// extracted by mini-css-extract-plugin
export var content = "_8a-3";
export var list = "_8a-4";
export var settingsContent = "_8a-7";
export var settingsPanel = "_8a-8";
export var state = "_8a-6";
export var triggerBadge = "_8a-2";
export var triggerButton = "_8a-1";
export var triggerShell = "_8a-0";
export var unreadDot = "_8a-5";